var _circle, _circle2, _path, _path2, _path3, _path4, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBookingTwoMonth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#A0CFDC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 35.045,
    cy: 35.2755,
    r: 18.4919,
    fill: "#A0CFDC",
    stroke: "#0F2A59",
    strokeWidth: 1.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.561 17.0645C22.561 20.5978 19.6974 23.4614 16.1641 23.4614C19.6974 23.4614 22.561 26.3251 22.561 29.8584C22.561 26.3251 25.4247 23.4614 28.958 23.4614C25.4247 23.4614 22.561 20.5978 22.561 17.0645Z",
    fill: "#A0CFDC",
    stroke: "#0F2A59",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1938 10.1406C24.1938 11.4581 23.126 12.5258 21.8086 12.5258C23.126 12.5258 24.1938 13.5936 24.1938 14.911C24.1938 13.5936 25.2616 12.5258 26.579 12.5258C25.2616 12.5258 24.1938 11.4581 24.1938 10.1406Z",
    fill: "#0F2A59",
    stroke: "#0F2A59",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9266 17.1367C15.9266 18.2785 15.0012 19.2039 13.8594 19.2039C15.0012 19.2039 15.9266 20.1293 15.9266 21.2711C15.9266 20.1293 16.8519 19.2039 17.9937 19.2039C16.8519 19.2039 15.9266 18.2785 15.9266 17.1367Z",
    fill: "#0F2A59",
    stroke: "#0F2A59",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2187 35.6337C49.5829 44.0866 42.5115 47.9771 42.5115 47.9771",
    stroke: "#0F2A59",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.8281,
    y: 52.0156,
    width: 26.7286,
    height: 2.93721,
    rx: 1.46861,
    fill: "#0F2A59"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1836,
    y: 55.541,
    width: 31.7219,
    height: 2.93721,
    rx: 1.46861,
    fill: "#0F2A59"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookingTwoMonth);
export default __webpack_public_path__ + "static/media/booking-twoMonth.8176ad193e9cefb929d7a5c28298a952.svg";
export { ForwardRef as ReactComponent };